import React, { useEffect, useState } from 'react';
import { Table, message, Modal } from 'antd';
import { Trash2, Edit, Eye, Plus } from 'lucide-react';
import { useParams, useNavigate } from 'react-router-dom';
import { getLeafAnalysisByExploitation, deleteLeafAnalysis } from '../../../Utils/analysis/leafAnalysis';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import Loading from '../../Shared/Loading';


const { confirm } = Modal;

const LeafAnalysis = () => {
  const { exploitationId } = useParams();
  const navigate = useNavigate();
  const [leafAnalysis, setLeafAnalysis] = useState([]);
  const [loading, setLoading] = useState(true);
  const userRole = useSelector((state) => state.user.userRole.name);



  const userLink = () => {
    if (userRole === 'client') {
      return '/client';
    } else if (userRole === 'admin' || userRole === 'superadmin') {
      return '/admin';
    } else if (userRole === 'domain_manager') {
      return '/domain-manager';
    } else if (userRole === 'exploitation_manager') {
      return '/exploitation-manager';
    }
  }
  useEffect(() => {
    fetchLeafAnalysis();
  }, [exploitationId]);

  const fetchLeafAnalysis = async () => {
    setLoading(true);
    try {
      const response = await getLeafAnalysisByExploitation(exploitationId);
      setLeafAnalysis(response.data);
    } catch (error) {
      console.error('Error fetching leaf analyses:', error);
      message.error('Failed to fetch leaf analyses');
    }
    setLoading(false);
  };

  const handleDelete = (id) => {
    confirm({
      title: 'Êtes-vous sûr de vouloir supprimer cette analyse foliaire ?',
      icon: <ExclamationCircleOutlined />,
      content: 'Cette action est irréversible.',
      okText: 'Oui',
      okType: 'danger',
      cancelText: 'Non',
      onOk: async () => {
        try {
          await deleteLeafAnalysis(id);
          message.success('Analyse foliaire supprimée avec succès');
          fetchLeafAnalysis();
        } catch (error) {
          console.error('Erreur lors de la suppression de l\'analyse foliaire:', error);
          message.error('Échec de la suppression de l\'analyse');
        }
      },
    });
  };

  const handleEdit = (record) => {
    navigate(`/admin/exploitation/${exploitationId}/edit-leaf-analysis/${record.analysis_id}`);
  };

  const handleView = (record) => {
    navigate(`${userLink()}/exploitation/${exploitationId}/view-leaf-analysis/${record.analysis_id}`)};

  const handleCreateAnalysis = () => {
    navigate(`/admin/exploitation/${exploitationId}/create-leaf-analysis`);
  };

  const columns = [
    { title: 'Sample', dataIndex: 'echantillon', key: 'echantillon' },
    {
      title: 'Date',
      dataIndex: 'date_realisation',
      key: 'date_realisation',
      render: (_, record) => new Date(record.date_realisation).toLocaleDateString()
    },
    { title: 'Laboratory', dataIndex: 'laboratoire', key: 'laboratoire' },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <span className="flex space-x-2">
          <Eye
            onClick={() => handleView(record)}
            className="text-green-500 cursor-pointer"
          />
          { (userRole === 'admin' || userRole === 'superadmin' || userRole === 'domain_manager') && 
            <>
              <Edit
                onClick={() => handleEdit(record)}
                className="text-blue-500 cursor-pointer"
              />
              <Trash2
                onClick={() => handleDelete(record.analysis_id)}
                className="text-red-500 cursor-pointer"
              />
            </>}
        </span>
      ),
    },
  ];


  return (
    <div className="w-full">
      {loading && <Loading />}
      <Table
        dataSource={leafAnalysis}
        columns={columns}
        rowKey="id"
      />
      {(userRole === 'admin' || userRole === 'superadmin' || userRole === 'domain_manager') &&
        <button
          className="fixed bottom-10 right-10 bg-blue-500 text-white p-4 rounded-full shadow-lg hover:bg-blue-600 transition duration-300 ease-in-out"
          onClick={handleCreateAnalysis}
        >
          <Plus />
        </button>}
    </div>
  );
};

export default LeafAnalysis;
